import React from "react";
import { Box } from "@origin-digital/ods-core";
import { ChangesTable } from "src/components/Changes";

export const ContentSection = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      data-id="contentSection.root"
    >
      <ChangesTable />
    </Box>
  );
};
